"use client";

import { ReactNode, useState } from "react";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import getQueryClient from "@/lib/get-query-client";
import { QueryClientProvider } from "@tanstack/react-query";
import AuthProvider from "./auth-provider";

interface AppProvidersProps {
  children: ReactNode;
  initialHasRefreshToken?: boolean;
}

export default function AppProviders({
  children,
  initialHasRefreshToken,
}: AppProvidersProps) {
  const [queryClient] = useState(() => getQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider initialHasRefreshToken={initialHasRefreshToken}>
        {children}
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </AuthProvider>
    </QueryClientProvider>
  );
}
